/*
 * @Description: 商机及商机管理有关语言包
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */
export default {
  角色: 'Role',
  完成: 'Completed',
  部门: 'Department',
  产品: 'Product',
  价格: 'Price',
  币种: 'Currency',
  折扣: 'Discount',
  数量: 'Quantity',
  小计: 'Subtotal',
  原因: 'Reason',
  '回退后，若已完成的阶段内有审批任务，需要重新提交审批': 'After the rejection, if there are approval tasks in the completed stage, you need to resubmit the approval.',
  暂不: 'Temporary Not',
  结束: 'End',
  负责人: 'Person in Charge',
  有效期: 'Validity Period',
  未开始: 'Not Started',
  进行中: 'In Progress',
  已完成: 'Completed',
  云文档: 'Cloud Document',
  本地附件: 'Local Attachment',
  标准价格: 'Standard Price',
  规格单位: 'Specification Unit',
  时长单位: 'Time Unit',
  销售单价: 'Sales Unit Price',
  商机导入: 'Business Opportunity Import',
  转移商机: 'Transfer Business Opportunity',
  商机产品: 'Business Opportunity Product',
  产品信息: 'Product Information',
  新增产品: 'Add Product',
  编辑产品: 'Edit Product',
  基本信息: 'Basic Information',
  系统信息: 'System Information',
  商机来源: 'Business Opportunity Source',
  商机阶段: 'Business Opportunity Stage',
  商机金额: 'Business Opportunity Amount',
  关单日期: 'Closing Date',
  暂无配置: 'No Configuration',
  上传出错: 'Upload Error',
  上传成功: 'Upload Success',
  协作阶段: 'Collaboration Stage',
  绩效比例: 'Performance Ratio',
  选择价格: 'Choose Price',
  产品名称: 'Product Name',
  变更原因: 'Change Reason',
  业绩参与人: 'Performance Participants',
  参与人角色: 'Participant Role',
  未发现客户: 'No Customer Found',
  请选择价格: 'Please Select Price',
  请选择币种: 'Please Select Currency',
  请输入数量: 'Please Enter Quantity',
  本阶段任务: 'This Stage Tasks',
  本阶段无任务: 'No Tasks in This Stage',
  新增协作阶段: 'Add Collaboration Stage',
  是否确认删除: 'Are You Sure To Delete?',
  已过期价格不可选: 'Expired Price Not Selectable',
  请输入销售单价: 'Please Enter Sales Unit Price',
  新增业绩参与人: 'Add Performance Participants',
  编辑业绩参与人: 'Edit Performance Participants',
  阶段变更成功: 'Stage Change Successful',
  批量转移商机: 'Batch Transfer of Business Opportunities',
  请输入回退原因: 'Please Enter Reason for Regression',
  请选择产品名称: 'Please Select Product Name',
  推进至当前阶段: 'Advance to Current Stage',
  回退至当前阶段: 'Regress to Current Stage',
  推进至下一阶段: 'Advance to Next Stage',
  当前阶段任务已全部完成: 'All Tasks in Current Stage Completed',
  请点击上传本地附件: 'Please Click to Upload Local Attachment',
  商机详情EXCEL模板: 'Business Opportunity Details EXCEL Template',
  请确认是否删除该产品: 'Please Confirm Whether to Delete This Product',
  暂无此商机查看权限: 'No Permission to View This Business opportunity',
  请先完成上一阶段全部任务: 'Please Complete All Tasks in the Previous Stage First',
  不支持转移的商机名称如下: 'Names of Business Opportunities Not Supported for Transfer',
  请填写阶段变更原因: 'Please fill in the reason for stage change',
  商机列表: 'Business opportunity list',
  请选择业绩参与人: 'Please select a performance participant',
  只能选择一个业绩参与人: 'Only one performance participant can be selected',
  请输入产品价格: 'Please enter the product price',
  请选择有效期: 'Please select a validity period',
  产品价格: 'Product Price',
  是必填项: 'is required',
  新增Call款: 'Add call',
  新增协议: 'Add agreement'
};
